"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable complexity */
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const app_error_styles_1 = __importDefault(require("./app-error.styles"));
const i18n = (0, pythia_libs_1.i18n)(['errors']);
const b = b_1.default.with('app-error');
const getMessage = (status, reason) => {
    if (reason) {
        switch (reason) {
            case 'ALREADY_FINISHED':
                return i18n(['survey', 'alreadyFinished']);
            case 'SURVEY_PAUSED':
                return i18n(['survey', 'paused']);
            case 'SURVEY_CLOSED':
                return i18n(['survey', 'closed']);
            case 'SURVEY_DOES_NOT_EXIST':
                return i18n(['survey', 'notFound']);
            default:
        }
    }
    switch (Number(status)) {
        case 404:
            return i18n(['page', 'notFound']);
        default:
            return i18n(['server', 'default']);
    }
};
function AppError({ message, reason, status, inited }) {
    if (!inited) {
        reason = null;
        status = null;
    }
    if (!status && !reason && !message) {
        return null;
    }
    if (!message) {
        message = getMessage(status, reason);
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: app_error_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('message'), "data-test": 'app-error-message' }, { children: message }))] })));
}
exports.default = AppError;
